import { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { notificationSocket } from "./notification.socket";

const NotificationProvider = ({ children }) => {
  const user = useSelector((state) => state.store.currentUser);
  const userId = user?._id;

  useEffect(() => {
    if (!userId) return;

    notificationSocket.connect();
    // notificationSocket.emit("join", userId);
    // notificationSocket.emit("join", `user-${userId}`);
    notificationSocket.emit("join", userId);


    const handleOrderNotification = (data) => {
      console.log("🔔 Order Notification:", data);
      toast.info(data.message, {
        position: "top-right",
        autoClose: 4000,
      });
    };

    notificationSocket.on(
      "order-notification",
      handleOrderNotification
    );

    return () => {
      notificationSocket.off(
        "order-notification",
        handleOrderNotification
      );
      notificationSocket.disconnect();
    };
  }, [userId]);

  return children;
};

export default NotificationProvider;
